import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { gettopperAPi, createtopperAPi,  uploadtopperAPi, deletetopperApi } from "../../../ApiUrl";
import { toast } from "react-toastify";

export const token = sessionStorage.getItem("accessToken")

const headers = {
    Authorization: `Bearer ${token}`,   
};
// create topper
export const createtopper = createAsyncThunk('createtopper/topper', async (formData, { rejectWithValue }) => {
    try {
        const response = await axios.post(createtopperAPi, formData, { headers })
        return response.data.message;
    } catch (error) {
        return rejectWithValue(error.response.data.message);
    }
})
export const updatetopper = createAsyncThunk('updatetopper/topper', async ({selectedId, formData }, { rejectWithValue }) => {
    try {
        const response = await axios.put(`${uploadtopperAPi}/${selectedId}`, formData, { headers })
        return response.data.message;
    } catch (error) {
        return rejectWithValue(error.response.data.message);
    }
})
// get topper
export const gettopper = createAsyncThunk('gettopper/topper', async () => {
    try {
        const response = await axios.get(`${gettopperAPi}?limit=`, { headers });
        return response.data; // Assuming your API response contains a 'toppers' property
    } catch (error) {
        throw new Error(error.message);
    }
});

// delete topper
export const deletetoppers = createAsyncThunk('deletetoppers/topper', async (topperid, { rejectWithValue }) => {
    try {
        const response = await axios.delete(`${deletetopperApi}/${topperid}`, { headers });
        return response.data._id; // Assuming your API response contains a 'topperid' property
    } catch (error) {
        return rejectWithValue(error.response.data.message);
    }
});



const topperSlice = createSlice({
    name: 'topper',
    initialState: {
        toppers: [],
        status: 'idle',
        error: null,
        message: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            //create topper
            .addCase(createtopper.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(createtopper.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.message = action.payload;
                if (state.status === 'succeeded') {
                    toast.success(state.message);
                }
                state.status = 'idle';

            })
            .addCase(createtopper.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
                if (state.status === 'failed') {
                    toast.error(state.error);
                }
            })
            //update topper
            .addCase(updatetopper.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(updatetopper.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.message = action.payload;
                if (state.status === 'succeeded') {
                    toast.success(state.message);
                }
                state.status = 'idle';

            })
            .addCase(updatetopper.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
                if (state.status === 'failed') {
                    toast.error(state.error);
                }
            })
            //gettoppers
            .addCase(gettopper.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(gettopper.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.toppers = action.payload;
            })
            .addCase(gettopper.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            })

            //delete toppers
            .addCase(deletetoppers.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(deletetoppers.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.toppers.data = state.toppers.data.filter(toppers => toppers.topperid !== action.payload);
                state.status = 'idle'
            })
            .addCase(deletetoppers.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            });
    }
});

export default topperSlice.reducer;
